import Vue from 'vue';

import layoutLogin from '@/layouts/layout-login';
import layoutAdmin from '@/layouts/layout-admin';

Vue.component('layout-login', layoutLogin);
Vue.component('layout-admin', layoutAdmin);



// WEBPACK FOOTER //
// ./src/global-components.js